import { EPublishPeriod, PublishPeriod } from 'shared/types/filters/advanced/publishPeriods';

export const PUBLISH_PERIOD_OPTIONS: PublishPeriod[] = [
  { label: 'За любую дату', value: EPublishPeriod.Any },
  { label: 'За месяц', value: EPublishPeriod.Month },
  { label: 'За неделю', value: EPublishPeriod.Week },
  { label: 'За сегодня', value: EPublishPeriod.Today },
  { label: 'За час', value: EPublishPeriod.Hour },
];
